/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function ($) {
	'use strict';
	/*globals Tc */

	/**
	 * ProductOfferPreviews
	 *
	 * @author Matthias Inauen
	 * @namespace Tc.Module
	 * @class ProductOfferPreviews
	 * @extends Tc.Module
	 */
	Tc.Module.ProductOfferPreviews = Tc.Module.extend({

		ANIMATION_DURATION: 400,
		THUMBNAIL_IMG_OPACITY: 0.6,
		THUMBNAIL_LABEL_OPACITY: 0.8,
		DEEPLINK_MARKER: 't',
		TRACKING_PHRASE: 'tab',

		stageBackgroundImages: null,
		productOfferSlides: null,
		thumbnails: null,
		slides: null,
		slideshowIntervalDuration: null,
		slideshowInterval: null,
		slideshowCanceled: true,
		promoLabelContainers: null,
		adServerSlides: [],
		isMobile: false,

		/**
		 * Terrific On method
		 * @param callback Function
		 */
		on: function (callback) {

			var mod = this,
				$ctx = mod.$ctx,
				stage = $('#scs-stage'),
				backgroundImages = "",
				stageBackgroundContainer = stage.find('.scs-stage-flat');

			$(document).on('adServerContentComplete', $.proxy(mod.handleAdserverContentComplete, mod));
			$(document).on('adServerContentLoaded', $.proxy(mod.handleAdserverContentLoaded, mod));
			$(document).on('adServerContentFailed', $.proxy(mod.handleAdserverContentFailed, mod));

			mod.productOfferSlides = $ctx.find('.product-offer-preview-slide');
			mod.thumbnails = $ctx.find('.thumbnail-links').find('li');
			mod.slides = $ctx.find('.slides > li');
			mod.promoLabelContainers = mod.slides.find('.modPromoLabel');
			mod.slideshowIntervalDuration = parseInt($ctx.data('duration')) * 1000;
			mod.isMobile = SCS.utils.isMobilePage();
			// quickfix because on tablets background videos tend to not work properly
			// so we just turn off background videos for tablets and treat everything as it would be mobile
			if(!mod.isMobile) {
				mod.isMobile = mod.mobileAndTabletcheck();
			}

			mod.isOldIE = $('html').is('.msIe9, .msIe8, .msIe7, .msIe6');
			mod.volumeButtons = $('.video-volume', $ctx);

			if (mod.productOfferSlides.length > 0) {
				if (stageBackgroundContainer.length > 0) {
					stageBackgroundContainer.remove();
				}

				stageBackgroundContainer = mod.makeStageBackgroundContainer(stage);

				mod.productOfferSlides.each(function (index) {
					var slide = $(this);

					if (slide.data('videourl') && !mod.isMobile && !mod.isOldIE) {
						backgroundImages += '<div class="scs-stage-backgroundcontainer"><div class="replacementVideoTag" data-is-video="true" data-src="' + slide.data("videourl") + '"><img src="" data-imagesource="' + slide.data('backgroundimage') + '"></div></div>'
					}
					else {
						backgroundImages += '<div class="scs-stage-backgroundcontainer"><img src="" data-imagesource="' + slide.data('backgroundimage') + '"></div>';
					}

					// cache the slides that will try to load content from an ad-server
					if (slide.data('wp-id')) {
						mod.adServerSlides.push({slide: slide, wpId: slide.data('wp-id'), index: index, wpplaceholderid: slide.data('wpplaceholderid')});
						mod.hideSlide(index);
					}
				});

				stageBackgroundContainer.append(backgroundImages);
				mod.stageBackgroundImages = stageBackgroundContainer.find('.scs-stage-backgroundcontainer');
				mod.stageBackgroundImages.fadeTo(0, 0);
			}

			mod.volumeButtons.on('click', $.proxy(mod.handleVideoVolume, mod));

			mod.$ctx.on('click', '.productofferslide a, .productofferslide button, .productofferslide input', function(){
				mod.cancelSlideshowInterval();
			});

			callback();
		},

		after: function () {
			var mod = this,
				deeplink = parseInt(SCS.HashDeepLink.get(mod.DEEPLINK_MARKER));

			// try the reach the deeplink, if that slide is not waiting for an adserver response.
			if (typeof(deeplink) !== 'undefined' && deeplink < mod.thumbnails.length) {
				mod.startWithSlide(deeplink, false);
			}
			// Only initialize if the first slide is not waiting for an ad-server response
			else if (!mod.adServerSlides.length || mod.adServerSlides[0].index !== 0) {
				mod.startWithSlide(0, true);
			}
		},

		/**
		 * Checks if the client is a mobile device or a tablet
		 */
		mobileAndTabletcheck : function() {
			var check = false;
			(function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4)))check = true})(navigator.userAgent||navigator.vendor||window.opera);
			return check;
		},


		/**
		 * Entry point to initialize the User Interface for the component
		 * @param index
		 */
		startWithSlide: function (index, enableAutoPlay) {
			var mod = this;
			index = (index === undefined || index === '') ? 0 : parseInt(index);

			if (mod.productOfferSlides.length > 1) {
				mod.thumbnails.off('click').on('click', $.proxy(mod.handleThumbnailClick, mod));

				if (mod.slideshowIntervalDuration > 0 && typeof(enableAutoPlay) !== 'undefined' && enableAutoPlay === true) {
					mod.setNextInterval();
					mod.slideshowCanceled = false;
				}
			}
			mod.activateSlideWithIndex(index);
		},


		/**
		 * A Make UI function. Generates the background container in the background of the stage using
		 * the regular stage mechanisms and styles. Appends the background images DOM with them actually loading images.
		 * @param stage jqueryObject of the stage
		 * @returns jqueryObject of the container containing the background images.
		 */
		makeStageBackgroundContainer: function (stage) {
			var backgroundOuterContainer = $('<div class="scs-stage-flat product-offer-previews-stage"></div>');
			var backgroundInnerContainer = $('<div class="scs-stage-flat-inner"></div>');

			if (stage.data("full-height")) {
				backgroundOuterContainer.addClass('full-height-background');
			}

			if (stage.data("bottom-align")) {
				backgroundOuterContainer.addClass('bottom-align-background');
			}

			if (stage.data("background-color").length > 0) {
				backgroundOuterContainer.css('background-color', "#" + stage.data("background-color"));
			}

			stage.append(backgroundOuterContainer);

			if (stage.data("stretch-image")) {
				backgroundOuterContainer.append(backgroundInnerContainer);
				return backgroundInnerContainer;
			}

			return backgroundOuterContainer;
		},

		/**
		 * Thumbnail click event handler
		 * @param event Object
		 */
		handleThumbnailClick: function (event) {
			var mod = this,
				target = $(event.currentTarget);

			if (!target.hasClass('active')) {
				mod.slideshowCanceled = true;
				mod.activateSlideWithIndex(target.index());
				mod.trackInteraction(target.index());
			}
		},

		/**
		 * Entry to point to switch to a new slide. Checks if the background of the new slide
		 * is already loaded, if not load the background first. The success handler of the loadBackgroundImage will then
		 * continue the flow.
		 * Otherwise call animateToSlide with the next valid slide index.
		 * @param slideIndex
		 */
		activateSlideWithIndex: function (slideIndex) {
			var mod = this,
				index = mod.getNextLoadedSlideIndex(slideIndex);
			if (index !== null) {
				var nextBackgroundImage = mod.stageBackgroundImages.eq(index);

				mod.cancelSlideshowInterval();

				var tmpTag = nextBackgroundImage.find(".replacementVideoTag");
				if(tmpTag.length > 0) {
					mod.makeRealVideoTag(tmpTag);
				}

				if (nextBackgroundImage.find('img').attr('src') === '') {
					mod.loadBackgroundImage(index)
				}
				else {
					mod.animateToSlide(index);
				}



			}
		},


		/*
		*	Creates a real video tag from a dummy div tag to speed up loading if a lot of videos are used
		*/
		makeRealVideoTag : function(replaceTag) {
			var videoUrl = replaceTag.data("src");
            var newTag = '<video muted="muted" src="' + videoUrl + '" poster="' + replaceTag.find("img").data("imagesource") + '">' + replaceTag.html() + '</video>';
            newTag = $(newTag);
            newTag.on('ended', function () {
              this.load();
              this.play();
            });
			replaceTag.replaceWith(newTag);
		},


		/**
		 * Loads the new background image and calls the animate to slide method on success.
		 * @param index
		 */
		loadBackgroundImage: function (index) {
			var mod = this,
				nextBackground = mod.stageBackgroundImages.eq(index),
				backgroundImage = nextBackground.find('img');

			backgroundImage.on('load', function () {
				var backgroundIndex = index;
				mod.animateToSlide(backgroundIndex);
			}).attr('src', (backgroundImage.data('imagesource')));

			if (backgroundImage[0].complete) {
				backgroundImage.off('load');
				mod.animateToSlide(index);
			}
		},

		/**
		 * Animates to the slide at the provided index. Should not be called directly.
		 * To switch to a slide always call activateSlideWithIndex(the-index);
		 * @param nextSlideIndex int
		 */
		animateToSlide: function (nextSlideIndex) {
			var mod = this,
				currentBackground = mod.stageBackgroundImages.filter(function () {
					return $(this).css('opacity') == 1;
				}),
				thumbnailLink = mod.thumbnails.eq(nextSlideIndex),
				nextBackground = mod.stageBackgroundImages.eq(nextSlideIndex),
				slide = mod.slides.eq(nextSlideIndex),
				slideContent = slide.find('.product-offer-preview-slide');

			mod.thumbnails.filter('.active').removeClass('active');
			thumbnailLink.addClass('active');

			mod.stageBackgroundImages.css('z-index', 0);
			currentBackground.delay(mod.ANIMATION_DURATION).fadeTo(mod.ANIMATION_DURATION, 0);
			nextBackground.css('z-index', 1).fadeTo(mod.ANIMATION_DURATION, 1);

			if (!mod.isOldIE) {
				if (currentBackground.children().eq(0).is('video')) {
					currentBackground.children()[0].pause();
				}

				if (nextBackground.children().eq(0).is('video')) {
					nextBackground.children()[0].play();
				}
			}

			mod.slides.stop().hide();
			slide.show().fadeTo(0, 0).delay(mod.ANIMATION_DURATION * 1.3).fadeTo((mod.ANIMATION_DURATION * 1.3), 1);

			if (slideContent.hasClass('themeWhite')) {
				$('.scs-pageheader > div').removeClass('scs-pageheader-themeDark').addClass('scs-pageheader-themeWhite');
			}
			else {
				$('.scs-pageheader > div').addClass('scs-pageheader-themeDark').removeClass('scs-pageheader-themeWhite');
			}
			mod.fire('productOfferPreviewAnimation', {activePromoLabel: mod.promoLabelContainers.eq(nextSlideIndex), duration: mod.ANIMATION_DURATION});

			if (!mod.slideshowCanceled) {
				mod.setNextInterval();
			}

			// set the deeplink of the active tab.
			SCS.HashDeepLink.set(mod.DEEPLINK_MARKER, nextSlideIndex);
		},

		/**
		 * Event handler for the slideshow interval
		 */
		handleSlideShowInterval: function () {
			var mod = this,
				activeThumbnailIndex = mod.thumbnails.filter('.active').index(),
				nextBackgroundIndex = mod.getNextSlideIndex(activeThumbnailIndex);
			mod.activateSlideWithIndex(nextBackgroundIndex);
		},

		/**
		 * Sets a new Timeout with call back
		 */
		setNextInterval: function () {
			var mod = this;
			mod.cancelSlideshowInterval();
			mod.slideshowInterval = setTimeout($.proxy(mod.handleSlideShowInterval, mod), mod.slideshowIntervalDuration);
		},

		/**
		 * Cancel the slide show interval
		 */
		cancelSlideshowInterval: function () {
			var mod = this;
			clearTimeout(mod.slideshowInterval);
		},

		/**
		 * Event handler for the adServerContentLoaded event sent by adserver.js
		 * Expects that the ad-server call was successful, the new DOM is loaded but not yet injected into the document
		 * @param event Object
		 * @param data Object
		 */
		handleAdserverContentLoaded: function (event, data) {
			var mod = this,
				productOfferSlideData = mod.getQueuedAdserverSlideData(data.wpplaceholderid),
				loadedSlideDOM = data.content.find('.product-offer-preview-slide'),
				contentLoadedAtIndex = (productOfferSlideData) ? productOfferSlideData.index : loadedSlideDOM.closest('li').index(),
				backgroundImage = mod.stageBackgroundImages.eq(contentLoadedAtIndex),
				thumbnail = mod.thumbnails.eq(contentLoadedAtIndex);

			// replace the background image
			backgroundImage.find('img').attr('src', loadedSlideDOM.data('backgroundimage')).data('imagesource', loadedSlideDOM.data('backgroundimage'));

			// if the new slide has a video url
			if (loadedSlideDOM.data('videourl') && !mod.isMobile && !mod.isOldIE) {
				// and is alreay a video slide
				if (backgroundImage.find('video').length) {
					// just replace the video
					backgroundImage.find('video').attr('src', loadedSlideDOM.data('videourl'));
				}
				else {
					// otherwise inject the video dom
					backgroundImage.find('img').wrap('<video muted="muted" loop="loop" src="' + loadedSlideDOM.data("videourl") + '"></video>');
				}
			}

			thumbnail.find('img').attr('src', loadedSlideDOM.data('thumbnailimage'));
			thumbnail.find('span').text(loadedSlideDOM.data('thumbnaillabel'));
		},

		/**
		 * Event handler for the adServerContentComplete event sent by adserver.js
		 * Expects that the ad-server call was successful, and the new content is already injected into the dom
		 * @param event Object
		 * @param data Object
		 */
		handleAdserverContentComplete: function (event, data) {
			var mod = this,
				$ctx = mod.$ctx,
				productOfferSlideData = mod.getQueuedAdserverSlideData(data.wpplaceholderid),
				contentLoadedAtIndex = (productOfferSlideData) ? productOfferSlideData.index : data.content.closest('li').index(),
				thumbnail = mod.thumbnails.eq(contentLoadedAtIndex);

			mod.productOfferSlides = $ctx.find('.product-offer-preview-slide');
			mod.slides = $ctx.find('.slides > li');
			mod.promoLabelContainers = mod.slides.find('.modPromoLabel');

			// initialize all modules
			SCS.utils.initNewModules(mod.productOfferSlides.eq(contentLoadedAtIndex));

			// re-enable volume buttons
			mod.volumeButtons.off('click');
			mod.volumeButtons = $('.video-volume', mod.$ctx);
			mod.volumeButtons.on('click', $.proxy(mod.handleVideoVolume, mod));

			mod.dequeueAdserverSlide(data.wpplaceholderid);

			thumbnail.find('img').stop().fadeTo(mod.ANIMATION_DURATION, mod.THUMBNAIL_IMG_OPACITY, function () {
				$(this).removeAttr('style');
			});
			thumbnail.find('span').stop().fadeTo(mod.ANIMATION_DURATION, mod.THUMBNAIL_LABEL_OPACITY, function () {
				$(this).removeAttr('style');
				if (contentLoadedAtIndex === 0) {
					mod.startWithSlide(0, true);
				}
			});
		},

		/**
		 * Event handler for the adServerContentFailed event sent by adserver.js
		 * Expects that the ad-server call did not work, hence we display the fall back contents
		 * @param event Object
		 * @param data Object
		 */
		handleAdserverContentFailed: function (event, data) {
			var mod = this,
				fallBackSlideData = null;

			// only proceed if the original DOM that made the ad-server call is still attached to the document
			if (data.origin.parent().length > 0) {
				fallBackSlideData = mod.getQueuedAdserverSlideData(data.wpplaceholderid);

				if (fallBackSlideData) {
					mod.dequeueAdserverSlide(data.wpplaceholderid);

					mod.thumbnails.eq(fallBackSlideData.index).find('img').fadeTo(mod.ANIMATION_DURATION, mod.THUMBNAIL_IMG_OPACITY, function () {
						$(this).removeAttr('style')
					});
					mod.thumbnails.eq(fallBackSlideData.index).find('span').fadeTo(mod.ANIMATION_DURATION, mod.THUMBNAIL_LABEL_OPACITY, function () {
						$(this).removeAttr('style')
					});
					mod.productOfferSlides.eq(fallBackSlideData.index).fadeTo(mod.ANIMATION_DURATION, 1, function () {
						if (fallBackSlideData.index === 0) {
							mod.startWithSlide(0, true);
						}
					});
				}
			}
		},

		/**
		 * Video Volume event handler
		 * Turns volume on corresponding video on and turns the volume for all other videos off
		 * Updates all volume indicators on the page.
		 */
		handleVideoVolume: function (event) {
			var mod = this,
				volumeButton = $(event.currentTarget),
				volumeOn = volumeButton.find('.video-volume-on'),
				volumeOff = volumeButton.find('.video-volume-off'),
				slideIndex = volumeButton.closest('li').index();

			if (volumeOn.hasClass('hidden')) {
				mod.stageBackgroundImages.eq(slideIndex).find('video')[0].muted = true;
				volumeOn.removeClass('hidden');
				volumeOff.addClass('hidden');
			}
			else {
				mod.stageBackgroundImages.eq(slideIndex).find('video')[0].muted = false;
				volumeOff.removeClass('hidden');
				volumeOn.addClass('hidden');
			}
		},

		/**
		 * Hides the contents of a slide for the purpose of waiting for its alternate contents from the adserver
		 * @param index int
		 */
		hideSlide: function (index) {
			var mod = this;

			mod.thumbnails.eq(index).find('img, span').fadeTo(0, 0);
			mod.productOfferSlides.eq(index).fadeTo(0, 0);

			if (mod.stageBackgroundImages) {
				mod.stageBackgroundImages.eq(index).fadeTo(0, 0);
			}
		},

		/**
		 * Retrieves the information about the product offer slide that is in the
		 * adserver queue that has the provided
		 * @param wpplaceholderid String
		 * @returns {*}
		 */
		getQueuedAdserverSlideData: function (wpplaceholderid) {
			var mod = this,
				productOfferSlide = null;

			for (var i = 0, length = mod.adServerSlides.length; i < length; i++) {
				if (mod.adServerSlides[i].wpplaceholderid.toString() === wpplaceholderid.toString()) {
					productOfferSlide = mod.adServerSlides[i];
					break;
				}
			}

			return productOfferSlide;
		},

		/**
		 * Removes one item out of the Adserver Queue
		 * @param wpplaceholderid String
		 */
		dequeueAdserverSlide: function (wpplaceholderid) {
			var mod = this;

			for (var i = 0, length = mod.adServerSlides.length; i < length; i++) {
				if (mod.adServerSlides[i].wpplaceholderid.toString() === wpplaceholderid.toString()) {
					mod.adServerSlides.splice(i, 1);
					break;
				}
			}
		},

		/**
		 * Returns the index of the next completely loaded slide of the current slide.
		 * @param slideIndex int
		 * @returns int
		 */
		getNextLoadedSlideIndex: function (slideIndex) {
			var mod = this,
				loopCount = 0,
				i = 0,
				adServerLength = mod.adServerSlides.length,
				thumbnailLength = mod.thumbnails.length,
				indexValid = false;

			// in case no slides have loaded yet, abort
			if (adServerLength === thumbnailLength) return null;

			if (mod.adServerSlides.length) {
				while (!indexValid && loopCount < thumbnailLength) {
					indexValid = true;
					for (i = 0; i < adServerLength; i++) {
						if (slideIndex === mod.adServerSlides[i].index) {
							indexValid = false;
							slideIndex = mod.getNextSlideIndex(slideIndex);
							break;
						}
					}

					loopCount++;
				}
			}
			return slideIndex;
		},

		/**
		 * Get the next valid slide index.
		 * @param currentIndex int
		 * @returns int
		 */
		getNextSlideIndex: function (currentIndex) {
			var mod = this;
			return ((currentIndex + 1) < mod.thumbnails.length ) ? (currentIndex + 1) : 0;
		},

		trackInteraction: function (index) {
			var siteCatalyst = window.s || window.s_one;
			if (siteCatalyst && siteCatalyst.pageName && siteCatalyst.channel && siteCatalyst.prop21 && siteCatalyst.t) {
				siteCatalyst.linkTrackVars = 'pageName,channel,prop18,prop19,prop20,prop21,prop39,evar14';
				siteCatalyst.pageName = siteCatalyst.pageName + "/" + this.TRACKING_PHRASE + index;
				siteCatalyst.channel = siteCatalyst.channel + "/" + this.TRACKING_PHRASE + index;
				siteCatalyst.prop21 = siteCatalyst.prop21 + ":" + this.TRACKING_PHRASE + index;
				siteCatalyst.t('virtual pageview');
			}
		}
	});
}(Tc.$));
}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/portal/clientlibs/desktop/js/modules/Tc.Module.ProductOfferPreviews.js
// module id = 171
// module chunks = 0